import { Component, Input } from '@angular/core';
import { AppState } from '../../../../app.service';
import { Service } from './vapps.service';
import { getDatatableConfig } from './vapps.dt.config';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { constructInnerTableVapp } from '../../dataprotection-common/common-renderers';
import { DataProtectionVariables } from '../../dataprotection-common/dataprotection-variables';
import { Modal } from '@clr/angular';
var $ = require('jquery');

@Component({
  selector: 'vapps',
  providers: [
    Service, TranslateService
  ],
  styles: [require('./vapps.scss')],
  template: require('./vapps.html')
})

export class Vapps {
  @Input('isVisible') isVisible: boolean;
  @Input('selectedVDC') selectedVDC;
  tableData:any = [];
  private subscribeHandler;

  private tableSettings : Object = {};
  private tableConfig : Object = {};
  private currentSelection;
  private selectedVapp;
  private isRestorePointsListeningEnabled: boolean = true;
  private isRowSelected: boolean = false;
  private isScheduleAvailable: boolean = false;
  private isTranslationready:boolean = true;
  private innerTableFunction:any = constructInnerTableVapp;
  private isApplyPolicyPopupVisible: boolean = false;
  private isDeletePolicyPopupVisible: boolean = false;
  private isAdhocBackupPopupVisible: boolean = false;
  private isConfigureEmailPopupVisible: boolean = false;
  private isRestorePointsPopupVisible: boolean = false;
  private isActivityLogPopupVisible: boolean = false;
  private applyPolicyPopupHeader:string;
  private deletPolicyPopupHeader:string;
  private adhocBackupPopupHeader:string;
  private configureEmailPopupHeader:string;
  private restorePointsPopupHeader:string;
  private activityLogPopupHeader:string;
  private applyPolicyPopupMode = DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VAPP'];
  private deletePolicyPopupMode = DataProtectionVariables.MODES['VAPP'];
  private configureEmailPopupMode = DataProtectionVariables.MODES['VAPP'];
  private restorePointPopupMode = DataProtectionVariables.RESTORE_MODES['VAPP'];
  private activityLogPopupMode:string = DataProtectionVariables.MODES['VAPP'];
  private gridClassesToListen:Array<string> = ['a.restore-points', 'span.handcursor'];
  private selectedVappArray;
  private showGridLoadingScreen: boolean = false;

  constructor(public appState: AppState, public service: Service, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
    this.tableConfig = getDatatableConfig(this.translate);
    Object.assign(this.tableSettings, this.tableConfig, {data: []});
  }

  ngOnChanges(changes) {
    /** Defer the REST call to fetch data, until the component is visible (else too many REST calls while loading).
     * This also helps in fixing the bug 'column headers are misaligned'
     * */
    if (changes &&
        changes.hasOwnProperty('isVisible') &&
        changes.isVisible &&
        changes.isVisible.hasOwnProperty('currentValue') &&
        changes.isVisible.currentValue &&
        this.selectedVDC &&
        this.selectedVDC.id) {
      this.getAllVapps();
    }
  }

  ngAfterViewInit() {
  }

  ngOnDestroy() {
    if (this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    }
  }

  onGridSelectionChange(event) {
    if (event && event.value && event.value instanceof Array ) {
      this.currentSelection = event.value;
      if (this.currentSelection.length > 0)
        this.isRowSelected = true;
      else
        this.isRowSelected = false;

      this.isScheduleAvailable = this.isScheduleAvailableForVapp();
    }
  }

  appendVappName() {
    let returnValue:string = "";
    if (this.currentSelection && this.currentSelection.constructor === Array && this.currentSelection.length > 0
      && this.currentSelection[0].hasOwnProperty('name')) {
        returnValue =  " - " + this.currentSelection[0].name;
    }
    return returnValue;
  }

  onApplyPolicy(event) {
    this.applyPolicyPopupMode = DataProtectionVariables.POLICY_POPUP_MODES['CREATE_VAPP'];
    this.isApplyPolicyPopupVisible = true;
    this.applyPolicyPopupHeader = this.translate.instant('dpsModule.applyPolicy.popupHeaderApplyPolicy') + this.appendVappName();

  }

  onEditPolicy(event) {
    this.applyPolicyPopupMode = DataProtectionVariables.POLICY_POPUP_MODES['UPDATE_VAPP'];
    this.isApplyPolicyPopupVisible = true;
    this.applyPolicyPopupHeader = this.translate.instant('dpsModule.applyPolicy.popupHeaderEditPolicy') + this.appendVappName();
  }

  onRemovePolicy(event) {
    this.isDeletePolicyPopupVisible = true;
    this.deletPolicyPopupHeader = this.translate.instant('dpsModule.deletePolicy.vapp.popupHeader') + this.appendVappName();
  }

  onRunAdhocBackup(event) {
    this.isAdhocBackupPopupVisible = true;
    this.adhocBackupPopupHeader = this.translate.instant('dpsModule.adhocBackup.popupHeader') + this.appendVappName();
  }

  onConfigureEmail(event) {
    this.isConfigureEmailPopupVisible = true;
    this.configureEmailPopupHeader = this.translate.instant('dpsModule.configureEmail.popupHeaderVapp') + this.appendVappName();
  }

  onChildClassClick(event) {
    if (event && event.childClass && event.rowData) {
      this.selectedVapp = event.rowData;
      switch(event.childClass){
        case this.gridClassesToListen[0]:
          this.openRestorePointDialog(event);
          break;
        case this.gridClassesToListen[1]:
          this.openActivityLogDialog(event);
          break;
      }
    }
  }

  openRestorePointDialog(event) {
    this.isRestorePointsPopupVisible = true;
    this.restorePointsPopupHeader = this.translate.instant('dpsModule.restorePoints.popupHeaderVapp') + ((this.selectedVapp && this.selectedVapp.name)? ' - ' + this.selectedVapp.name : '');
  }

  openActivityLogDialog(event) {
    this.selectedVappArray = [this.selectedVapp];
    this.isActivityLogPopupVisible = true;
    this.activityLogPopupHeader = this.translate.instant('dpsModule.cards.vapp.dialogTitles.activityLog') + ((this.selectedVapp && this.selectedVapp.name)? ' - ' + this.selectedVapp.name : '');
  }

  isScheduleAvailableForVapp() {
    let retrurnValue:boolean = false;
    if (this.isRowSelected &&
        this.currentSelection &&
        this.currentSelection.constructor === Array &&
        this.currentSelection.length > 0 &&
        this.currentSelection[0].hasOwnProperty('schedule') &&
        this.currentSelection[0].schedule) {
      retrurnValue = true;
    }
    return retrurnValue;
  }


  onApplyPolicyClose(event) {
    if (event && event.value) {
      this.isApplyPolicyPopupVisible = false;
      this.getAllVapps();
    }
  }

  onDeletePolicyClose(event) {
    if (event && event.value) {
      this.isDeletePolicyPopupVisible = false;
      this.getAllVapps();
    }
  }

  onAdhocBackupClose(event) {
    if (event && event.value) {
      this.isAdhocBackupPopupVisible = false;
    }
  }

  onConfigureEmailClose(event) {
    if(event && event.value) {
      this.isConfigureEmailPopupVisible = false;
    }
  }

  //Custom Logic
  getAllVapps() {
    if (this.selectedVDC && this.selectedVDC.id) {
      this.showGridLoadingScreen = true;
      this.subscribeHandler = this.service.getAllVapps(this.selectedVDC.id)
        .subscribe(
          tableData => {
            this.tableData = tableData;
          },
          error => this.logError(error, 'get all vApps'),
          () => this.logOperationCompleted('get vApps')
        );
    }
    else
      this.logError('Incorrect VDC information while loading vapps');
  }


  logError(error, origin:String = '') {
    console.error('Error: ', error, (origin !== '')? " Error from " + origin : "");
  }

  logOperationCompleted(msg: string) {
    //console.log('Operation Completed: ', msg)
    this.showGridLoadingScreen = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/vapps/vapps.component.ts